import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { ParagraphLarge, useBreakpoint } from "@tal-gel/components-v2";
import styled from "@emotion/styled";

import { ApplicationState } from "../../redux/initialState";
import OrganisationCard from "./organisationCard";
import getFilteredServices from "../../selectors/serviceSelector";
import { Organisation } from "../../features/organisation/organisationTypes";
import { fetchOrganisations } from "../../features/organisation/organisationActions";
import { ColumnFlexBox } from "../common/FlexBoxes";

interface PropsFromState {
  data: Organisation[];
}

interface propsFromDispatch {
  fetchOrganisations: () => any;
}

type AllProps = PropsFromState & propsFromDispatch;

const CardGrid = styled.div<{ columns: number }>`
  display: flex;
  gap: 32px;
  width: 100%;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  flex: 1;
`;

const OrganisationList: React.FC<AllProps> = ({ data, fetchOrganisations }) => {
  const [firstLoad, setLoad] = useState<boolean>(false);
  useEffect(() => {
    if (!data.length && !firstLoad) {
      fetchOrganisations();
    }
    // we need this to not trigger fetching new organisation data from confluence after initial load
    if (data.length !== 0) {
      setLoad(true);
    }
  }, [data.length, fetchOrganisations]);

  // Responsive columns using useBreakpoint
  const isXL = useBreakpoint("xl");
  const isLG = useBreakpoint("lg");
  const isMD = useBreakpoint("md");
  const isSM = useBreakpoint("sm");
  let columns = 1;
  if (isXL || isLG) columns = 3;
  else if (isMD) columns = 2;
  else if (isSM) columns = 1;

  // Custom horizontal masonry logic
  const columnArrays: Organisation[][] = Array.from({ length: columns }, () => []);
  data.forEach((item, idx) => {
    const colIdx = idx % columns;
    columnArrays[colIdx].push(item);
  });

  return (
    <ColumnFlexBox style={{ maxWidth: "1080px", gap: "16px", justifyContent: "center", alignItems: "center", margin: "0 auto" }}>
      <ParagraphLarge style={{ alignSelf: "flex-start", marginLeft: 0 }}>{data.length} results</ParagraphLarge>
      <CardGrid columns={columns}>
        {columnArrays.map((col, i) => (
          <Column key={i}>
            {col.map(item => (
              <OrganisationCard key={item.id} item={item} />
            ))}
          </Column>
        ))}
      </CardGrid>
    </ColumnFlexBox>
  );
};

const mapStateToProps = (state: ApplicationState) => {
  return {
    data: getFilteredServices(state),
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    fetchOrganisations: () => {
      dispatch(fetchOrganisations());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganisationList);
